/** Values must match options in campaign-details-step.js (Awareness Targeted Group). */

export function defaultAwarenessTargetedGroupForAttack(attackType) {
	if (!attackType) return "";
	if (attackType === "Attachment") return "Attachment Opened";
	if (attackType === "Vishing") return "datasubmitted";
	return "linkclicked";
}

export function isAwarenessTargetValidForAttack(attackType, value) {
	if (!value || !String(value).trim()) return false;
	if (attackType === "Attachment") return value === "Attachment Opened";
	if (attackType === "Vishing") return value === "datasubmitted";
	return value === "linkclicked" || value === "datasubmitted";
}

/**
 * For Simulation Attack + Training with Instant Awareness on:
 * - Leave the group unset (empty) until the user picks one — do not auto-select a default.
 * - If a value is present but invalid for the current attack type, fall back to the attack default.
 */
export function resolveAwarenessTargetedGroupForInstantOn(
	simulationType,
	attackType,
	instantAwareness,
	currentGroup
) {
	if (simulationType !== "Simulation Attack + Training" || !instantAwareness) {
		return currentGroup || "";
	}
	const g = (currentGroup || "").trim();
	if (!g) return "";
	if (isAwarenessTargetValidForAttack(attackType, g)) return g;
	return defaultAwarenessTargetedGroupForAttack(attackType);
}
